import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { DsLoggingService, LocalStorageKey } from '@cubigo/digital-signage';

import { timeout } from 'rxjs';

import { AuthService } from 'app/shared/services';
import { ConfigDataService } from 'app/shared/services/data';

import { environment } from 'environments/environment';

import { SIGNAGE_API } from './signage-api-context';

export const headerInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.context.get(SIGNAGE_API)) {
    return next(request);
  }

  const auth = inject(AuthService);
  const logging = inject(DsLoggingService);
  const configuration = inject(ConfigDataService).configuration();
  const region = (localStorage.getItem(LocalStorageKey.DataCenterPrefix) || '').toUpperCase();
  const key = region === 'EU' ? environment.ocpApimSubscriptionKeyEu
    : region === 'CA' ? environment.ocpApimSubscriptionKeyCa : environment.ocpApimSubscriptionKey;
  const headers: Record<string, string> = {
    'Ocp-Apim-Subscription-Key': key,
    'Accept-Language': localStorage.getItem(LocalStorageKey.DSLanguage) || 'en-US'
  };
  const traceId = logging.getTraceId();

  if (traceId) {
    headers['x-ms-request-root-id'] = traceId;
  }

  if (configuration?.channel?.providerUuid) {
    headers['CommunityUuid'] = configuration.channel.providerUuid;
  }

  if (auth.accessToken) {
    headers['Authorization'] = `Bearer ${auth.accessToken}`;
  }

  if (logging.deviceId) {
    headers['device-Id'] = logging.deviceId;
  }

  if (logging.userAgent) {
    headers['x-user-agent'] = logging.userAgent;
  }

  return next(request.clone({ setHeaders: headers })).pipe(timeout(30_000));
};
